type JsonRecord = Record<string, unknown>;

function safeParseJsonRecord(raw: string | null | undefined): JsonRecord | null {
    const trimmed = (raw ?? '').trim();
    if (!trimmed) return null;

    try {
        const parsed = JSON.parse(trimmed) as unknown;
        if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) return null;
        return parsed as JsonRecord;
    } catch {
        return null;
    }
}

function coercePositiveInt(value: unknown): number | null {
    if (typeof value === 'number' && Number.isFinite(value) && value > 0) return Math.floor(value);

    if (typeof value === 'string') {
        const parsed = Number(value);
        if (Number.isFinite(parsed) && parsed > 0) return Math.floor(parsed);
    }

    return null;
}

export function extractAgentMode(initialContextJson: string | null | undefined): string | null {
    const obj = safeParseJsonRecord(initialContextJson);
    const mode = obj?.agentMode;
    if (typeof mode !== 'string') return null;
    const trimmed = mode.trim();
    return trimmed ? trimmed : null;
}

export function extractAutopilotPlanId(params: {
    autopilotPlanId?: number | null | undefined;
    initialContextJson?: string | null | undefined;
}): number | null {
    const direct = coercePositiveInt(params.autopilotPlanId);
    if (direct !== null) return direct;

    const obj = safeParseJsonRecord(params.initialContextJson);
    if (!obj) return null;
    return coercePositiveInt(obj.autopilotPlanId);
}
